import React from 'react';

const DrawerHeader: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className = '', children, ...props }) => (
  <header className={`linq-drawer-header oo-drawer-main-header ${className}`} {...props}>
    {children}
  </header>
);

export default DrawerHeader;
